export const settings = {
  word: "settings",
  hello: "Hello",
  save_changes: "Save Changes",
  change: "Change",
  abort: "Cancel",
  email: {
    change_email: "Change Email Address",
    current_email: "Your current email address is:",
  },
  username: {
    change_username: "Change Username",
    current_username: "You are currently using the username:",
  },
  profile: {
    title: "Profile",
  },
  profileImage: {
    change_profile_image_in_settings:
      "Change your profile picture / username in the profile settings.",
    tooltip_add_profile_image: "Add / change profile picture",
  },
  account: {
    delete_account: "Delete Account",
    email_changed: "Your email address has been changed.",
  },
  password: {
    reset_password: "Reset Password",
    labels: {
      password: "Password",
    },
  },
};
